import { Category } from '../../../../../types';

export const excludeChildrenByIdentifier = (
  data: Category[],
  exclude: string[],
): Category[] =>
  data.map((category) => ({
    ...category,
    childCategories: (category.childCategories ?? []).filter(
      (child) => !exclude.includes(child.identifier),
    ),
  }));
